module.exports = __webpack_public_path__ + "img/videoTechnicalSupport.541dc38c.jpg";